import { render, staticRenderFns } from "./WardMessageContacts.vue?vue&type=template&id=b653921e&scoped=true&"
import script from "./WardMessageContacts.vue?vue&type=script&lang=js&"
export * from "./WardMessageContacts.vue?vue&type=script&lang=js&"
import style0 from "./WardMessageContacts.vue?vue&type=style&index=0&id=b653921e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b653921e",
  null
  
)

export default component.exports